import React, { createContext, useContext } from 'react'

const MediaContext = createContext(false)

export const useMediaContext = () => {
  return useContext(MediaContext)
}

const isMedia = true
export default function MediaProvider({ children }) {
  return <MediaContext.Provider value={isMedia}>{children}</MediaContext.Provider>
}
